import React from "react";
import {cn} from "../utils";

const TransferIcon = (
        {
            className,
            color
        }: {
            className?: string,
            color?: string
        } & React.SVGProps<SVGSVGElement>) => (

        <svg fill="none"
             height="512"
             width="512"
             viewBox="0 0 24 24"
             className={cn(className)}
             xmlns="http://www.w3.org/2000/svg">
            <g clipRule="evenodd"
               fill={color || "currentColor"}
               fillRule="evenodd">
                <path
                    d="m1.25 4c0-1.51878 1.23122-2.75 2.75-2.75h6c1.5188 0 2.75 1.23122 2.75 2.75v4c0 1.51878-1.2312 2.75-2.75 2.75h-6c-1.51878 0-2.75-1.23122-2.75-2.75zm2.75-1.25c-.69036 0-1.25.55964-1.25 1.25v4c0 .69036.55964 1.25 1.25 1.25h6c.6904 0 1.25-.55964 1.25-1.25v-4c0-.69036-.5596-1.25-1.25-1.25z"/>
                <path
                    d="m11.25 16c0-1.5188 1.2312-2.75 2.75-2.75h6c1.5188 0 2.75 1.2312 2.75 2.75v4c0 1.5188-1.2312 2.75-2.75 2.75h-6c-1.5188 0-2.75-1.2312-2.75-2.75zm2.75-1.25c-.6904 0-1.25.5596-1.25 1.25v4c0 .6904.5596 1.25 1.25 1.25h6c.6904 0 1.25-.5596 1.25-1.25v-4c0-.6904-.5596-1.25-1.25-1.25z"/>
                <path
                    d="m20.6036 6.75-.7197.71967c-.2929.29289-.2929.76777 0 1.06066s.7678.29289 1.0606 0l1.2929-1.29289c.6835-.68342.6835-1.79146 0-2.47488l-1.2929-1.29289c-.2928-.29289-.7677-.29289-1.0606 0s-.2929.76777 0 1.06066l.7197.71967h-4.6036c-.4142 0-.75.33579-.75.75s.3358.75.75.75z"/>
                <path
                    d="m3.39645 18.75.71967.7197c.29289.2929.29289.7677 0 1.0606-.2929.2929-.76777.2929-1.06066 0l-1.2929-1.2929c-.68341-.6834-.68342-1.7914 0-2.4748l1.2929-1.2929c.29289-.2929.76776-.2929 1.06066 0 .29289.2929.29289.7677 0 1.0606l-.71967.7197h4.60355c.41421 0 .75.3358.75.75s-.33579.75-.75.75z"/>
            </g>
        </svg>
    )
;

export {TransferIcon};